var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-slider" },
    [
      _c("h2", { staticClass: "image-slider__heading" }, [
        _vm._v(_vm._s(_vm.settings.heading))
      ]),
      _c("h3", { staticClass: "image-slider__sub-heading" }, [
        _vm._v(_vm._s(_vm.settings.sub_heading))
      ]),
      _c(
        "VueSlickCarousel",
        _vm._b(
          {
            staticClass: "image-slider__slider",
            scopedSlots: _vm._u([
              {
                key: "prevArrow",
                fn: function(arrowOption) {
                  return [
                    _c("icon-button", {
                      attrs: { icon: "arrow-left", size: "20px" }
                    })
                  ]
                }
              },
              {
                key: "nextArrow",
                fn: function(arrowOption) {
                  return [
                    _c("icon-button", {
                      attrs: { icon: "arrow-right", size: "20px" }
                    })
                  ]
                }
              }
            ])
          },
          "VueSlickCarousel",
          _vm.sliderSettings,
          false
        ),
        _vm._l(_vm.slides, function(slide, index) {
          return _c(
            "div",
            {
              key: "image-slider_" + _vm._uid + "_slide" + index,
              staticClass: "image-slider__slide",
              on: {
                click: function($event) {
                  return _vm.navigate(slide.link, $event)
                }
              }
            },
            [
              _c("img", {
                staticClass: "image-slider__image",
                attrs: { src: slide.src, alt: slide.alt, draggable: "false" }
              })
            ]
          )
        }),
        0
      ),
      _vm.settings.cta_url
        ? _c("base-button", { attrs: { href: _vm.settings.cta_url } }, [
            _vm._v(_vm._s(_vm.settings.cta_text))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }